import sensors from 'sa-sdk-javascript';
import { UserVariables } from '../variables';

/**
 * 设置用户变量
 *
 * @template T
 * @param {T} variables
 */
const setUserVariables = <T extends UserVariables>(variables: T) => {
  // if (gioIsValid()) {
  //   window.gio('people.set', variables);
  // }
  sensors.setProfile(variables);
};

export default setUserVariables;
